import { Controller } from '@hotwired/stimulus'
import Typewriter from 'typewriter-effect/dist/core'

export default class extends Controller {
  static targets = ['typewriterContainer']
  static values = {
    typewriterSentences: {
      type: Array,
      default: [
        'AI Innovation',
        'Web Development',
        'iOS/Android App Development',
        'Workflow Automation',
        'Ads And Campaigns',
        'E-Commerce Solutions'
      ]
    }
  }

  typewriterContainerTargetConnected(element) {
    const typewritter = new Typewriter(element, {
      loop: true,
      delay: '100'
    })

    this.typewriterSentencesValue.forEach(sentence => {
      typewritter
        .typeString(sentence)
        .pauseFor(2000)
        .deleteAll()
    })

    typewritter.start()
  }
}
